export default __webpack_public_path__ + "static/media/Shape 43.dc02224f.svg";